import { type QuoteConstraint, type Quote } from '../../../modules/quotes'

export type ConstraintsFilter = (quote: Quote) => QuoteConstraint[]

export enum QuotesView {
  best = 'best',
  cheapest = 'cheapest',
  bestRated = 'bestRated',
}

export type QuotesViewHandler = {
  sort: (quotes: Quote[]) => Quote[]
  getConstraints?: ConstraintsFilter
}
